import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',/////路由不带#号   hash 路由带有#号
  base: '',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.saveSrollTop) {
        from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
      }
      return {x: 0, y: to.meta.savedPosition || 0};
    }
  },

})
// 判断登录是否过期 获取code之后判断
console.log(window.location.href)
let param =  window.location.href.split('code=')[1]

let code = param?param.split('&')[0]:''
//发送请求验证是否已登录y

console.log(code)
let userRoles
router.beforeEach(({ meta, path }, from, next) => {
  (!!sessionStorage.userRoles) ? userRoles = JSON.parse(sessionStorage.userRoles).rights : userRoles = []
  const isLogin = Boolean(localStorage.getItem('token'))
  if(code){
  
  }
  if(meta &&  meta.title){
console.log(meta)
    if (!isLogin && path !== '/m/login') {
     
        let to = { path: '/m/login' }
        return next(to)
      }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js